const initializeSearchDrawer = () => {
  const searchDrawerEl = document.querySelector('#fs-search-drawer')
  if (!searchDrawerEl) {
    return
  }
  addEvents(searchDrawerEl)
}


const addEvents = (searchDrawerEl) => {
  searchDrawerEl.addEventListener('show', () => {
    show(searchDrawerEl)
  })
  searchDrawerEl.addEventListener('hide', () => {
    hide(searchDrawerEl)
  })

  const backdrop = searchDrawerEl.querySelector('.fs-backdrop')
  backdrop.addEventListener('click', () => {
    hide(searchDrawerEl)
  })

  searchDrawerEl.querySelector('.fs-close-button').addEventListener('click', () => {
    hide(searchDrawerEl)
  })
}


const show = (searchDrawerEl) => {
  const backdrop = searchDrawerEl.querySelector('.fs-backdrop')
  const container = searchDrawerEl.querySelector('.fs-container')

  container.style.display = 'block'
  backdrop.classList.add('show')
  setTimeout(() => {
    container.classList.add('show')
  }, 100)
}


const hide = (searchDrawerEl) => {
  const backdrop = searchDrawerEl.querySelector('.fs-backdrop')
  const container = searchDrawerEl.querySelector('.fs-container')

  backdrop.classList.remove('show')
  container.classList.remove('show')
  setTimeout(() => {
    container.style.display = 'none'
  }, 500)
}


/*
 * Main
 */


const searchDrawerMain = () => {
  initializeSearchDrawer()
}


searchDrawerMain()
